<template>
  <div class="form-group">
    <label :for='valueKey'>
      {{label}}
      <validation-message
        :required="required"
        :invalid="invalid"
        :errorMessage="errorMessage" />
    </label>

    <input
      v-if="enableMask && !focused"
      :class="modifier"
      :value="mask"
      v-mask="obscuredMask"
      @focus="showSSN"
    />

    <input
      v-else
      :class="modifier"
      :disabled="disabled"
      v-model="internalValue"
      :required="required"
      :errorMessage="errorMessage"
      :invalid="invalid"
      ref="ssnInput"
      @blur="focused = false"
    />
  </div>

</template>

<script>
  import ValidationMessage from '@atoms/ValidationMessage'

  export default {
    components: { ValidationMessage },
    props: {
      label: String,
      valueKey: String,
      focus: {
        type: Function,
        default: () => {}
      },
      enableMask: Boolean,
      autofocus: String,
      minlength: String,
      required: {
        type: Boolean,
        default: false
      },
      value: {
        type: String,
        default: ''
      },
      name: String,
      id: String,
      disabled: Boolean,
      onFocus: {
        type: Function,
        default() {}
      },
      modifier: {
        type: String,
        default: 'form-input'
      },
      invalid: {
        type: Boolean,
        default: false
      },
      errorMessage: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        focused: false
      }
    },
    methods: {
      showSSN() {
        this.focused = true

        setTimeout(() => {
          if (this.$refs.ssnInput) { this.$refs.ssnInput.focus() }
        }, 250)
      }
    },
    computed: {
      internalValue: {
        get () {
          return this.value
        },
        set (newVal) {
          this.$emit('input', newVal)
        }
      },
      mask() {
        return (this.value || '').split('').map(c => '#').join('')
      },
      obscuredMask() {
        return (this.value || '').split('').map(c => 'X').join('')
      }
    }
  }
</script>
